import { APIVersion, axios } from "../../Config/config.js";
// axios.defaults.baseURL = basePath;
const GetBanners_cards = async (banner_id) => {
  return await axios.get(`${APIVersion}banners/${banner_id}/`);
};
const createBanners = async (payload) => {
  return await axios.post(`${APIVersion}banners/`, payload);
};

const updateBanners = async (payload, banner_id) => {
  return await axios.put(`${APIVersion}banners/${banner_id}/`, payload);
};

const deleteBanner = async (banner_id) => {
  return await axios.delete(`${APIVersion}banners/${banner_id}/`);
};
export { updateBanners, deleteBanner, GetBanners_cards, createBanners };
